export const splitHash = (hash: string) => {
  const [payByLinkId, propertyHash] = hash.split('.').reverse();
  return { payByLinkId, propertyHash };
}
